<div class="container">
  <div
    class="cookie-consent"
    [class.active]="isActive"
    [attr.aria-hidden]="!isActive ? 'true' : null">
    <div class="description">
      <p class="txt">
        We use cookies to improve user experience and analyze website traffic. By clicking "Accept",
        you agree to our website's cookie use as described in our
        <a href="" (click)="showPolicy($event)">Cookie Policy</a>.
      </p>
      <div class="btn">
        <a href="" (click)="onAccept($event)">Accept</a>
      </div>
    </div>
  </div>
</div>
